module.exports = __webpack_public_path__ + "static/media/how_it_work_4.2b463f87.png";